import React, { Component } from 'react';
import { Button, Icon, Grid, List, ListItem, Image, Popup, Modal, ModalContent } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL, WEB_URL } from '../App.js';
import '../App.css';
import { TagColors, AudioSource, speakerPictures } from './SearchHelper.js';
import {nounoptions1, nounoptions2, options1, options2, options3, customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam} from './constants/constants.js'
import * as Scroll from 'react-scroll';
import ReactGA from "react-ga4";
import Recorder from './Recorder.js';

ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;
// let customFontFam = "Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif"

let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
}

let innerWidthSetting = 480

class Entry extends Component {
	constructor(props) {
		super(props);

    // console.log(decodeURI(props.match.params.word))

		// console.log(props)
		this.state = {
			word: decodeURI(props.match.params.word),
			history: props.location.state === undefined ? [] : props.location.state.history,
			from: props.location.state === undefined ? '' : props.location.state.from,
			// prevCategory: props.location.state === undefined ? 'all' : ('currentCategory' in props.location.state ? props.location.state.currentCategory:'all'),
			// parseIndex:0,

			// children:[],
    	// lexicon:'',
    	// pos:'',
    	// varsp:[],
    	// gloss:[],
    	soundfile:'',
    	semantic_domain:[],
    	dialect:[],
    	activeAudioIndex:{},
    	openPopup:-1,
    	showModal:-1,
    	// reversal:[],
    	// examples:[],
    	// Possessed:'',
    	// PossTlingit:'',
    	// possValue:'311',
    	// Verb_Root:'',
    	// LeerEdwards_Theme:[],
    	// NaishStory_Theme:'',
    	// Conjugation_Prefix:'',
    	// Motion_Verbtype:'',
    	// Valence:'',
    	// Pronoun:'',
    	// notes1:[],
    	// notes2:[],
    	// verb_paradigms:[],
    	// verb_paradigms_roots:[],
    	// verb_paradigms_processed:{},
    	// noun_paradigms:[],
    	// adverb_paradigms:[],
			// siblings:[],
			// homonyms:[],
			// properties:[],

    	// loaded:false,

			// moodPOS:[],
			// POSCandidateList:[],
			// sortValue:0,

			// boldedsubject: true,
			// displaypos: true,
		}
	    // this.getWord = this.getWord.bind(this);
	    // this.getWord(decodeURI(props.match.params.word));
	    scroll.scrollTo(0);
	}

	// componentDidMount(){

	// }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.word !== this.props.match.params.word) {
    	// this.initializeWord()
    	scroll.scrollTo(0);
    }
  }


  componentWillReceiveProps(nextProps) {
    // console.log(nextProps)
    this.setState({ 
			from: nextProps.location.pathname,
			// fullDefinition: nextProps.fullDefinition,
		})
	}


	processStyledText = (sentence) => {
		if (sentence !== undefined) {
			sentence = sentence.replace("⟨","").replace("⟩","").replace("«","").replace("»","")
			let matches = sentence.match(/⎡.*?⎤/g)
			let matches1 = sentence.match(/{.*?}/g)
			let matches2 = sentence.match(/_.*?_/g)
			if (matches !== null || matches1 !== null || matches2 !== null) {
				if (matches !== null) {
					matches.map((m) => sentence = sentence.replace(m,'<i>'+m.slice(1,-1)+'</i>'))						
				}
				if (matches1 !== null) {
					matches1.map((m) => sentence = sentence.replace(m,m.slice(1,-1)))						
				}
				if (matches2 !== null) {
					matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))						
				}
				return <span dangerouslySetInnerHTML={{__html: sentence}} />		
			} else {
				return <span>{sentence}</span>
			}
		}
	}

    processStyledTextLink = (sentence) => {
      sentence = sentence.replaceAll(">","")


      sentence = sentence.replaceAll("⟨","").replaceAll("⟩","")
      let matches = sentence.match(/⎡.*?⎤/g)
      let matches1 = sentence.match(/{.*?}/g)
      let matches2 = sentence.match(/_.*?_/g)
      // console.log(matches2)
      if (matches !== null || matches1 !== null || matches2 !== null) {
        if (matches !== null) {
          matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
        }
        if (matches1 !== null) {
          matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
        }
        if (matches2 !== null) {
          matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
        }
        return <span style={{whiteSpace:'nowrap'}} dangerouslySetInnerHTML={{__html: sentence}} />    
      } else {
        return <span style={{whiteSpace:'nowrap'}}>{sentence}</span>
      }

    }


  convertrjatuk = (phrase) => {
		var text = phrase.toLowerCase();
		text = text.replace("ā","A")
		text = text.replace("b","B")
		text = text.replace("c","C")
		text = text.replace("d","D")
		text = text.replace("e","E")
		text = text.replace("f","F")
		// text = text.replace("g","g")
		text = text.replace("q̄","H")
		text = text.replace("ō","I")
		text = text.replace("j","J")
		// text = text.replace("a","a")
		text = text.replace("ġ","b")
		text = text.replace("t̄","c")
		text = text.replace("p̄","d")
		text = text.replace("ł","e")
		text = text.replace("ŋ","f")
		// text = text.replace("g","g")
		// text = text.replace("h","h")
		// text = text.replace("i","i")
		text = text.replace("ḷ","j")
		// text = text.replace("k","k")
		// text = text.replace("l","l")
		// text = text.replace("m","m")
		// text = text.replace("n","n")
		text = text.replace("ł̣","o")
		// text = text.replace("p","p")
		// text = text.replace("q","q")
		// text = text.replace("r","r")
		// text = text.replace("s","s")
		// text = text.replace("t","t")
		// text = text.replace("u","u")
		// text = text.replace("v","v")
		// text = text.replace("w","w")
		// text = text.replace("x","x")
		return text
  }

  setActiveAudioIndex = (word, index) => {
    console.log(word, index)
    let activeAudioIndex = this.state.activeAudioIndex
    if (index in activeAudioIndex) {
      delete activeAudioIndex[index]
      this.setState({activeAudioIndex:activeAudioIndex})
    } else {
      // activeAudioIndex[index] = ""
      // this.setState({activeAudioIndex:activeAudioIndex})
      // console.log(word)

      axios
        .get(API_URL + "sugtstunaudiolibraryword/" + word.key)
        .then(response => {
          // let end = now();
          // ReactGA.timing({
          //   category: 'Loading',
          //   variable: 'dictionary',
          //   value: (end-start).toFixed(3),
          //   label: 'Dictionary loading'
          // });
          // audiolibrary = response.data;
          // fuse.setCollection(dictionary);
          // fuse1.setCollection(dictionary);
          console.log(response.data);
          activeAudioIndex[index] = response.data
          this.setState({activeAudioIndex:activeAudioIndex})
          // activeAudioIndex[index] = response.data
          // this.setState({activeAudioIndex:activeAudioIndex})

          // dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
          // dictionary_prepared = fuzzysort.prepare(dictionary)

          // this.setState({ audiolibrary: audiolibrary });
        });


    }
    // console.log(activeAudioIndex)
    // this.setState({activeAudioIndex:activeAudioIndex})
  }



  repeatAudio(id, inu, event, data) {
    console.log(id, inu, event, data)

    if (!this.state.playingAudio) {
      let sound = new Audio(API_URL + "sugtstunaudiolibrary/" + id);
      this.setState({playingAudio: true});

      sound.play()

      sound.onended=()=>{
        this.setState({playingAudio: false});
      }
    }
  }

  recordClip = (sentenceid, sentence, siteLocation, english) => {
        return <Modal
            on='click'
            open={this.state.showModal==sentenceid}
            style={{
              maxWidth:500,
              marginTop:(window.innerWidth < 480 ? 10 : 10),
            }}
            closeOnDimmerClick={false}
            onOpen={()=>{
            }}
            onClose={()=>{
              this.setState({showModal:-1})
            }}
          >
          <ModalContent>
            <Icon circular style={{margin:0,color:'#929292',cursor:'pointer',position:'relative',float:'right'}} size='large' onClick={()=>{this.setState({showModal:-1});}} name='x' />
            <Recorder english={english} sentence={sentence} siteLocation={siteLocation} />          
          </ModalContent>
          </Modal>
  }


  displayAudioMic = (audioRetrieved, sentenceid) => {
    console.log(audioRetrieved)
    return <Popup
            content={
              <List style={{fontFamily:customFontFam}} divided verticalAlign='middle'>
                {audioRetrieved.map((k,kindex)=>{
                  return <ListItem style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <Button style={{float:'left', border:(this.state.playingAudio && this.state.clickedAudioIndex === kindex ? 'solid 1px #4a80b5' : 'solid 1px #dededf'),marginLeft:5,backgroundColor:'white', color:(k['village'] == 'computer generated' ? '#929292' : '#106181'),cursor:'pointer'}} circular icon='volume up' onClick={()=>this.repeatAudio(k['mp3'], kindex)} />
                          <div style={{display:'flex',flexDirection:'column',marginLeft:10,padding:'5px 0px'}}>
                          	{k['key']}
{/*                            {k['gender'] != 'do_not_wish_to_say' ?
                              <div>{k['gender'].replaceAll('_',' / ')}</div>
                              :
                              null
                            }
                            {k['age'] != 'do_not_wish_to_say' ?
                              <div>{k['age']}</div>
                              :
                              null
                            }
                            {k['village'] != 'do_not_wish_to_say' ?
                              <div>{k['village']}</div>
                              :
                              null
                            }
                            {(k['gender'] == 'do_not_wish_to_say' || k['gender'] == '') && (k['age'] == 'do_not_wish_to_say' || k['age'] == '') && (k['village'] == 'do_not_wish_to_say' || k['village'] == '') ?
                              <div>{'Anonymous'}</div>
                              :
                              null
                            }    */}                        
                          </div>
                        </ListItem>
                })}
                <ListItem style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                  <Button circular basic style={{opacity:0.9,marginLeft:5,fontSize:'14px'}} onClick={()=>{this.setState({openPopup:-1},()=>{this.setState({showModal:sentenceid})})}} icon='microphone' />
                  <div style={{marginLeft:10,padding:'5px 0px'}}>Submit a Recording</div>
                </ListItem>
              </List>
              }
            on='click'
            open={this.state.openPopup==sentenceid}
            onClose={()=>this.setState({openPopup:-1})}
            style={{padding:8}}
            position='bottom center'
            trigger={<Button onClick={()=>{this.setState({openPopup:sentenceid})}} style={{paddingRight:15, marginLeft:10,marginTop:1}} circular basic icon>{audioRetrieved.length == 0 ? <Icon style={{color:'#929292'}} name='microphone' /> : (audioRetrieved.length == 1 && audioRetrieved[0]['village'] == 'computer generated' ? <Icon style={{color:'#929292',fontSize:'16px'}} name='volume up' /> : <Icon style={{color:'#106181',fontSize:'16px'}} name='volume up' />)}<Icon style={{color:'#d2d2d2',paddingLeft:'6px',fontSize:'11px'}} name='chevron down' /> </Button>}
          />
  }


	render() {
		console.log(this.state)
    let currentEntry = this.props.dictionarydict[this.state.word]
    console.log(currentEntry)

    const formatTime = (totalSeconds) => {
      if (isNaN(totalSeconds) || totalSeconds < 0) return '00:00';
      
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

		return (
			<div className="app" style={{fontFamily:customFontFam}}>


      <Grid textAlign='center'>
      <Grid.Row style={{paddingBottom:0}}>
        <Grid.Column style={{ maxWidth: 860, padding: 0 }} textAlign='left'>
						<Link to={{pathname: "/search", state: { history:this.state.history, homeMode:0 }}} >
	          	<Button basic style={{paddingLeft:'10px',paddingRight:'15px',marginLeft:'3px'}} icon='left chevron' content='Back to Search' />
	          </Link>
 					<Button basic style={{float:'right',paddingLeft:'13px',paddingRight:'15px'}} icon='linkify' onClick={() => {navigator.clipboard.writeText(WEB_URL+'?p=search/'+currentEntry['id']); this.setState({copyClicked:true})}} content={this.state.copyClicked ? 'Copied!' : 'Share Link'} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
      <Grid.Column style={{ maxWidth: 860, padding: 10 }} textAlign='left'>

					<div style={{fontSize:'23px',marginTop:'10px',fontFamily:customFontFam}}>
						<div>
          		<div style={{display:'flex',paddingBottom:'7px'}}> 
              <span style={{fontWeight:'500',lineHeight:'30px'}}>
              {this.processStyledTextLink(currentEntry['sugtstun'])}
{/*              	{typeof currentEntry.mp3 !== "undefined" && currentEntry.mp3.length !== 0 ?
									<Icon circular onClick={()=>this.repeatAudio(currentEntry.mp3[0].mp3)} style={{marginLeft:'12px',fontSize:'16px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
									:
									null
              	}*/}


                {typeof currentEntry.mp3 !== "undefined" && currentEntry.mp3.length !== 0 ?
                  this.displayAudioMic(currentEntry.mp3, 1)
                  :
                  null
                }

                {this.state.showModal != -1 ?
                  this.recordClip(1,currentEntry.sugtstun,'entryTitle',currentEntry.english)
                  :
                  null
                }



              </span>

   
              </div>
            </div>
					</div>

					<div style={{fontSize:'18px',marginTop:'5px',color:'#000000cc'}}>
						<div style={{marginBottom:'8px',lineHeight:'22px'}}>

              {currentEntry.everything[0].pos_final.length !== 0 ?
	              <span>
		                <span style={{marginRight:'5px'}}>
		                  <TagColors tags={currentEntry.everything[0].pos_final} size='mini' width={-1} />
		                </span>    
	              </span>
	              :
	              null
	            }

						</div>
					</div>

					<div style={{border:'1px solid #E3E3E3',marginTop:'14px'}}>


					{'e' in currentEntry && currentEntry['english'].length != 0 ?
					<div>
						<div className='hierarchymain'>
						<span className='span1'></span>
						<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Definition</span>
						</div>

						<div style={{marginTop:'17px',marginBottom:'18px'}}>
							<div style={{display:'flex',alignItems:'center',margin:'13px 0px',marginBottom:'10px'}}>
							<span style={{marginLeft:'10px',color:'#777777',fontSize:'20px','fontWeight':'300'}}>{'○'}</span>
							<span style={{marginLeft:'20px',color:'#000000',fontSize:'20px',lineHeight:'24px'}}>
							{this.processStyledText(currentEntry['english'])}
							</span>
							</div>

							</div>
						</div>
						:
						null
					}



					{'sentences' in currentEntry && currentEntry['sentences'].length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Example Sentences</span>
							</div>

							{currentEntry['sentences'].map((d,ind) => 
								<div style={{marginTop:'18px'}}>



									<div style={{marginTop:'15px',marginLeft:'22px',marginBottom:'11px',fontSize:'20px'}}>
									{this.processStyledText(d['sugtstun'])}
									{d['audiofilename'].length > 0 ?
										<Icon circular onClick={()=>this.repeatAudio(d['audiofilename'])} style={{marginLeft:'16px',fontSize:'17px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
										:
										null
									}
									</div>


									<div style={{marginBottom:'18px',marginLeft:'22px',fontSize:'17px',color:'#000000DE'}}>
									<span>
									{this.processStyledText(d['english'])}
									</span>
{/*									<span style={{marginLeft:'4px'}}>
									{this.processStyledText(d['sugtstun'])}
									</span>*/}
									</div>

								</div>
								)}
						</div>
						:
						null
					}


					{'mp3AudioLibrary' in currentEntry && currentEntry['mp3AudioLibrary'].length !== 0  ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Audio Library Matches</span>
							</div>
							<List divided style={{margin:0}}>
                {currentEntry['mp3AudioLibrary'].map((word, index) => {
                return <List.Item style={{padding:10}}>
                  <Icon circular onClick={()=>this.repeatAudio(word.mp3)} style={{float:'left',marginRight:'10px',fontSize:'17px',color:(word.mp3.includes('ems') && !(word.mp3.includes('Phrasebook')) ? '#5b6c85': (false ? '#6a7f56':'#7e6464')),cursor:'pointer'}} name='volume up' />
                  <Button style={{float:'right', color:'#8F8F8F',cursor:'pointer'}} basic icon='info' onClick={()=>this.setActiveAudioIndex(word,index)} />
                  <List.Content>
                    <List.Header style={{width:'100%',display:'flex',fontFamily:customFontFam,lineHeight:'20px',fontSize:'16px',fontWeight:'500'}}>
                        <span>{word.s}</span>
                    </List.Header>
                    <List.Description style={{paddingTop:'2px',fontFamily:customFontFam,lineHeight:'20px',fontSize:'16px',fontWeight:'400'}}>
                        <span>{word.e}</span>
                    </List.Description>            
                      {index in this.state.activeAudioIndex ?
                        <AudioSource index={index} activeAudioIndex={this.state.activeAudioIndex[index]} />         
                        :
                        null
                      }
                  </List.Content>
                </List.Item>
                })}

							</List>
{/*							<Link to={{pathname: "/", state: { history:this.state.history, homeMode:1 }}} >
								<Button style={{justifyContent:'center',margin:10}} basic>{'See more examples in audio library'}</Button>
		          </Link>*/}
						</div>
						:
						null
					}


					{true  ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Ending Tables</span>
							</div>
							<a target="_blank" href={"https://www.wiinaq.org/ems/search/?q="+currentEntry['sugtstun']}>
								<Button style={{justifyContent:'center',margin:10}} basic>{'Search '+currentEntry['sugtstun']+' on Wiinaq.org'}</Button>
		          </a>
						</div>
						:
						null
					}

				</div>

					<div style={{paddingTop:'10px',paddingBottom:'30px',paddingLeft:'8px'}}>
			    <Link to={{pathname: '/report'}}>
						<Icon style={{color:'#a9a9a9',}} name='exclamation circle' />
						<span style={{fontSize:'14px',color:'#9d9d9d',fontWeight:'400',lineHeight:'23px'}}>Report an Issue</span>
          </Link>
					</div>


				</Grid.Column>
				</Grid.Row>
				</Grid>
			</div>
		);
	}
}
export default Entry;